<script lang="ts">
  import { Badge } from "@/components/ui/badge"

  type TaskStatus = "pending" | "completed" | "pending_approval" | "approved" | "paid" | "rejected"

  interface Props {
    status: TaskStatus
  }

  let { status }: Props = $props()

  const statusConfig: Record<
    TaskStatus,
    { label: string; variant: "default" | "secondary" | "outline" | "destructive" }
  > = {
    pending: { label: "Pending", variant: "outline" },
    completed: { label: "Completed", variant: "secondary" },
    pending_approval: { label: "Pending Approval", variant: "outline" },
    approved: { label: "Approved", variant: "default" },
    paid: { label: "Paid", variant: "default" },
    rejected: { label: "Rejected", variant: "destructive" },
  }

  const config = statusConfig[status]
</script>

<Badge variant={config.variant}>{config.label}</Badge>
